import styled from 'vue-styled-components';

export const Icon = ['no-producers', 'no-results', 'no-alerts', '404'] as const;

export const Wrapper = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column
`;
